import React, { Component } from 'react';
import './NavMenu.css';
export default class NavMenu extends Component {
	constructor(props){
		super(props)
	}
	render() {
		return (<div className="nav-menu">
			</div>)
	}
}
